<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">查看平台</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="170px">
        <el-form-item label="平台号:">
          <span>{{ basicInfo.code }}</span>
        </el-form-item>
        <el-form-item label="平台名称:"> {{ basicInfo.name }} </el-form-item>
        <el-form-item label="公司名称:"> {{ basicInfo.companyName }} </el-form-item>
        <el-form-item label="开票资质:">
          <!-- {{ basicInfo.invoice==0?'无':'有' }} -->
          <el-switch v-model="basicInfo.invoice" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" disabled></el-switch>
        </el-form-item>
        <el-form-item label="收款账号:" v-show="basicInfo.invoice"> {{ basicInfo.collectionAccount }} </el-form-item>
        <el-form-item label="户名:" v-show="basicInfo.invoice"> {{ basicInfo.accountName }} </el-form-item>
        <el-form-item label="开户行:" v-show="basicInfo.invoice"> {{ basicInfo.bank }} </el-form-item>
        <el-form-item label="营业执照:" v-show="basicInfo.invoice">
          <el-image style="max-width:200px" v-if="basicInfo.licenseUrl !== undefined && basicInfo.licenseUrl !== ''" class="yingye" :src="basicInfo.licenseUrl"
            :preview-src-list="[basicInfo.licenseUrl]">
          </el-image>
        </el-form-item>
        <el-form-item label="支付方式:">
          <el-select v-model="basicInfo.paymentType" placeholder="请选择" disabled class="customer-select">
            <!-- <el-option label="码支付" value="CODE"></el-option> -->
            <el-option label="余额支付" value="BALANCE"></el-option>
            <el-option label="在线支付" value="ONLINE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="微信二维码:">
          <el-image style="max-width:200px" v-if="basicInfo.qrCode !== undefined && basicInfo.qrCode !== ''" class="yingye" :src="basicInfo.qrCode" :preview-src-list="[basicInfo.qrCode]"></el-image>
        </el-form-item>
        <el-form-item label="是否为淘宝平台:">
          <el-switch v-model="basicInfo.tbOrder" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否支持生成核销码:">
          <el-switch v-model="basicInfo.supportVerificationCode" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否为抖音平台:">
          <el-switch v-model="basicInfo.dyOrder" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否为获客平台:">
          <el-switch v-model="basicInfo.acquisition" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否设置代理价格:">
          <el-switch v-model="basicInfo.agentPrice" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" disabled></el-switch>
        </el-form-item>
        <el-form-item label="是否开通云底片:">
          <el-switch v-model="basicInfo.cloudFilm" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" disabled></el-switch>
        </el-form-item>
        <el-form-item label="是否开通预约服务:">
          <el-switch v-model="basicInfo.appointment" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" disabled></el-switch>
        </el-form-item>
        <el-form-item label="产品分享给客户:">
          <el-switch v-model="basicInfo.isProductShare" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" disabled></el-switch>
        </el-form-item>
        <el-form-item label="是否支持APP:">
          <el-switch v-model="basicInfo.supportApp" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" disabled></el-switch>
          <span style="margin-left: 10px;color:red;">注：仅自营店铺可打开此开关</span>
        </el-form-item>
        <el-form-item label="是否为渠道客户:">
          <el-switch v-model="basicInfo.channelCustomer" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" disabled></el-switch>
          <span style="margin-left: 10px;color:red;font-size: 12px;">注:1.余额支付并开启，需要配置第三方的小程序名称，ID，密钥和图标，如鼎星；2.在线支付并开启，需要配置第三方小程序名称，ID，密
            钥和图标，商户ID，密钥路径，证书序列号，APPlv3密钥。C端客户支付到B端微信账户，后台自动扣B端平台余额的金额。如：冉逸</span>
        </el-form-item>
        <el-form-item label="是否为余额自动支付:">
          <el-switch v-model="basicInfo.automaticPayment" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" disabled></el-switch>
          <span style="margin-left: 10px;color:red;">注:开启后产品可生成余额支付码和余额支付电子卡券，C端客户使用码券提交的订单平台余额自动支付</span>
        </el-form-item>
        <el-form-item label="是否自定义小程序首页:">
          <el-switch v-model="basicInfo.diyHomepage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" disabled></el-switch>
          <span style="margin-left: 10px;color:red;">注：开启后平台可自行个性化设置小程序首页界面模块的图片和顺序</span>
        </el-form-item>
        <el-form-item label="小程序名称:" v-if="basicInfo.channelCustomer"> {{ basicInfo.wxConfigList[0].appletName }} </el-form-item>
        <el-form-item label="小程序ID:" v-if="basicInfo.channelCustomer"> {{ basicInfo.wxConfigList[0].appId }} </el-form-item>
        <el-form-item label="小程序密钥:" v-if="basicInfo.channelCustomer"> {{ basicInfo.wxConfigList[0].wxsecret }} </el-form-item>
        <el-form-item label="小程序图标:" v-if="basicInfo.channelCustomer">
          <el-image style="max-width:200px" v-if="basicInfo.wxConfigList[0].icon" class="yingye" :src="basicInfo.wxConfigList[0].icon" :preview-src-list="[basicInfo.wxConfigList[0].icon]">
          </el-image>
        </el-form-item>
        <el-form-item label="商户Id:" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'"> {{ basicInfo.wxConfigList[0].merchantId }} </el-form-item>
        <el-form-item label="私钥路径:" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'"> {{ basicInfo.wxConfigList[0].privateKeyPath }} </el-form-item>
        <el-form-item label="证书序列号:" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'"> {{ basicInfo.wxConfigList[0].merchantSerialNumber }} </el-form-item>
        <el-form-item label="APIv3秘钥:" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'"> {{ basicInfo.wxConfigList[0].apiV3Key }} </el-form-item>
        <el-form-item label="是否使用公钥验签:" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'"> {{ basicInfo.wxConfigList[0].wechatPublicPay == 1 ? '是' : '否' }} </el-form-item>
        <el-form-item label="公钥路径:" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'"> {{ basicInfo.wxConfigList[0].publicKeyPath }} </el-form-item>
        <el-form-item label="公钥Id:" v-if="basicInfo.channelCustomer && basicInfo.paymentType == 'ONLINE'"> {{ basicInfo.wxConfigList[0].publicKeyId }} </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import { storeTypeGetStoreTypeList, vipStoreQueryByStoreId } from '@/api/crm'
export default {
  name: 'check-plateform',
  data () {
    return {
      storeMsg: {},
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      basicInfo: {
        address: {
          // fullAddress: ''
        },
        storeTypeBean: {
          id: null
        }
      },
      platformType: [],
      isRepeat: false,
      isCheckedRepeat: false
    }
  },
  created () {
    let id = this.$route.query.id
    storeTypeGetStoreTypeList().then((res) => {
      this.platformType = res.data.data
    })
    vipStoreQueryByStoreId(id).then((res) => {
      if (res.data.success) {
        let obj = {}
        obj = res.data.data
        obj.sendFlag = obj.sendFlag === undefined ? '0' : obj.sendFlag
        if (!obj.address) {
          obj.address = {}
        }
        if (res.data.data.storeTypeBean === undefined) {
          obj.storeTypeBean = {
            id: ''
          }
        }
        this.basicInfo = obj
      }
    })
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
